import { EJNotificationEventItem, Permission } from '@cims-online/shared'
import { EditNotificationEventOptionsFn } from 'components/CIMSNotifications/types'
import { useCallback } from 'react'
import { useUpsertEjNotificationMutation } from 'schema'
import { useEJNotificationsContext } from '../../EJNotificationsContext'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleEditNotification } from 'hooks/notificationHandler'
import { useRecipientsSelectContext } from 'components/CIMSSelect/common/RecipientsSelect/RecipientsSelectContext'
import RenderFormItems from './components/RenderFormItems'
import { LabeledValueType } from 'components/CIMSSelect/types'
import { useProjectContext } from 'context/ProjectContext'

export function useEdit() {
  const { projectId } = useProjectContext()
  const { recipients, refetch } = useEJNotificationsContext()
  const { toLabeledValues, fromLabeledValues } = useRecipientsSelectContext()
  const [edit] = useUpsertEjNotificationMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      upsertEJNotification: {
        notification: { notificationEvent },
      },
    }) => simpleEditNotification(notificationEvent),
  })
  return useCallback<
    EditNotificationEventOptionsFn<
      { every: LabeledValueType[] },
      EJNotificationEventItem
    >
  >(
    (event) => {
      const { every } = recipients(event)
      return {
        permission: Permission.EditEJNotification,
        initialValues: {
          every: toLabeledValues(every),
        },
        onClear: async () => {
          await edit({
            variables: {
              input: {
                every: { userIds: [], nonUserEmailIds: [] },
                notificationEventId: event.id,
                projectId,
              },
            },
          })
        },
        onSave: async ({ every }) => {
          await edit({
            variables: {
              input: {
                projectId,
                notificationEventId: event.id,
                every: fromLabeledValues(every),
              },
            },
          })
          refetch()
        },
        render: <RenderFormItems />,
      }
    },
    [edit, fromLabeledValues, projectId, recipients, refetch, toLabeledValues]
  )
}
